// extracted by mini-css-extract-plugin
export default {"Modal":"ErrorModal_Modal__L8hsD","Buttons":"ErrorModal_Buttons__yXuQ8","ErrorIcon":"ErrorModal_ErrorIcon__iDGv+"};